import { render, staticRenderFns } from "./NoBrandFavoritesAnimatedIcon.vue?vue&type=template&id=97169c3a&scoped=true"
import script from "./NoBrandFavoritesAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./NoBrandFavoritesAnimatedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97169c3a",
  null
  
)

export default component.exports